import version from '../version.json'
// eslint-disable-next-line
console.log(Object.entries(version).filter(([k, v]) => v).map(t => t.join(':')).join(', '))
